/**
 * Strip demo query prefills (address, project, session) but keep city/portal.
 * Call after startNewCitizenRequest so React Router updates and forms stay blank.
 */
export function citizenNewRequestSearch(searchParams) {
  const next = new URLSearchParams();
  const city = searchParams?.get?.('city') || searchParams?.get?.('packageId');
  const portal = searchParams?.get?.('portal');
  if (city) next.set('city', city);
  if (portal) next.set('portal', portal);
  const s = next.toString();
  return s ? `?${s}` : '';
}
